// Angular
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'kt-open-pdf-dialog',
  templateUrl: './open-pdf.component.html',
})
export class OpenPdfComponent {
  index = 0;

  constructor(
    public dialogRef: MatDialogRef<OpenPdfComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  onNoClick(): void {
    this.dialogRef.close();
  }

  Next() {
    if (this.index < this.data.attachments.length) {
      this.index++;
    }
  }

  Previous() {
    if (this.index > 0) {
      this.index--;
    }
  }
}
